import Skeleton from "react-loading-skeleton";

import { useUsers } from "~/hooks";
import { User } from "~/shared.types";
import { tw } from "~/utils";
import { Avatar } from "./Avatar";

interface UserInformationProps {
  className?: string;
}

const fullName = (user: User) => {
  return `${user.firstName} ${user.lastName}`;
};

export const UserInformation = ({ className }: UserInformationProps) => {
  const { getCurrentUser } = useUsers();

  const { data: currentUser } = getCurrentUser();

  return (
    <div className={tw("flex items-center gap-2 px-4 py-3", className)}>
      <Avatar />

      <div className="text-indigo min-w-0 overflow-hidden">
        <p className="truncate text-sm font-semibold">
          {currentUser ? (
            fullName(currentUser)
          ) : (
            <Skeleton width={200} height={20} />
          )}
        </p>

        <p className="overflow-hidden text-ellipsis text-sm font-normal">
          {currentUser ? (
            currentUser.email
          ) : (
            <Skeleton width={200} height={20} />
          )}
        </p>
      </div>
    </div>
  );
};
